import Icon from '../components/Icon.vue'

Icon.register({
  socks: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M214.7 311L288 256V96H128V272L41.4 336.6C1.9 366.2-12.5 421 12.1 463.7 30.4 495.3 63.3 512 96.1 512 116.1 512 136.3 505.8 153.6 492.8L175.5 476.4C145.6 421 161.9 350.6 214.7 311zM288 32C288 20.9 291.1 10.7 296 1.6 293.4 0.9 290.9 0 288 0H160C142.3 0 128 14.3 128 32V64H288V32zM480 0H352C334.3 0 320 14.3 320 32V64H512V32C512 14.3 497.7 0 480 0zM320 272L233.9 336.6C194.5 366.2 180 421 204.7 463.7 222.9 495.3 255.3 512 288.1 512 308.1 512 328.3 505.8 345.6 492.8L460.8 406.4A128-128 0 0 1 512 304V96H320V272z'
      }
    ]
  }
})
